import React from 'react'

export default function RightCard(props) {
    return (
        <div>
            <div className="hidden md:flex  space-x-10 justify-between mt-20">
                <div className="">
                    <h1 className="text-4xl font-mono text-green-200 mb-5">{props.name}</h1>
                    <p className="font-serif text-black-100 mb-10 text-xl">{props.description}</p>
                    <div className="flex flex-wrap text-black-800">
                        {props.tags.map((tag) =>
                            <span className="rounded-full border-2 mr-2 mt-1 mb-1 border-black-100 pl-2 pr-2 p-1 text-black-100">{tag}</span>
                        )}
                    </div>
                </div>

                <div className="flex flex-col justify-center flex-shrink-0">
                    <div className="relative  group hover:scale-110 transition-all duration-1000">
                        <img src={`/${props.image}`} alt="project image" className="w-96 h-60 object-cover object-center bg-green-400" />
                        <div className="absolute bg-black-100 opacity-40 w-96 h-60 top-0 left-0 filter mix-blend-multiply  hover: cursor-pointer"></div>
                        <div className="absolute opacity-80 w-96 h-0 top-0 left-0 filter mix-blend-multiply  hover: cursor-pointer group-hover:h-60 transition-all text-green-800"></div>
                    </div>

                    <div className="mt-5 flex justify-end space-x-6">
                        {props.links.map(content => {
                            return <a href={`${content.link}`} target="_blank" rel="noreferrer">
                                <img src={`/${content.name}`} alt="link image" className="w-7 h 7 hover cursor-pointer hover:scale-110 transition-all opacity-70 hover:opacity-90" />
                            </a>
                        })}
                    </div>
                </div>
            </div>

            <div className="md:hidden bg-black-300 flex flex-col p-4 mt-20 rounded-lg m-auto w-11/12">
                <div>
                    <h1 className="text-4xl text-center font-mono text-green-200 mb-5">{props.name}</h1>
                    <p className="font-serif text-white-300 mb-10 text-xl">{props.description}</p>
                    <div className="flex flex-wrap text-black-800">
                        {props.tags.map((tag) =>
                            <span className="rounded-full border-2 mr-2 mt-1 mb-1 border-black-100 pl-2 pr-2 p-1 text-black-100">{tag}</span>
                        )}
                    </div>
                    <div className="mt-5 flex justify-end space-x-6">
                        {props.links.map(content => {
                            return <a href={`${content.link}`} target="_blank" rel="noreferrer">
                                <img src={`/${content.name}`} alt="link image" className="w-6 h 6 hover cursor-pointer hover:scale-110 transition-all opacity-70 hover:opacity-90" />
                            </a>
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}
